<template>
  <div class="warp_edificiosView">
    <headView :option="title" :subtitleOpt="subtitleOpt"></headView>
    <div class="edificiosView_body">
      <div class="edificiosView_body__title">
        <p class="title">Edificios</p>
      </div>
      <div class="edificiosView_body__list">
        <div class="edificiosView_body_List-item" v-for="(item, index) in edificios" :key="index">
          <div class="box_left">
            <div class="item_name">
              <b-input class="input-custom input-custom--view input-custom--high" placeholder="Nombre del Punto de Control" v-model="item.name" disabled></b-input>
            </div>
            <div class="item_direccion">
              <b-input class="input-custom input-custom--view input-custom--high" placeholder="Direccion" v-model="item.address" disabled></b-input>
            </div>
            <div class="item_select item_distrito">
              <b-select placeholder="Elija el distrito" class="input-select-custom select-custom-no" v-model="item.district" @input="putEdificio(item.district, item.id, 'distrito')" :disabled="!roleEdit">
                <option
                  v-for="distrito in distritos"
                  :value="distrito.name"
                  :key="distrito.id">
                  {{ distrito.name }}
                </option>
              </b-select>
            </div>
            <div class="item_select item_tipo">
              <b-select placeholder="Elija el tipo" class="input-select-custom select-custom-no"  v-model="item.type" @input="putEdificio(item.type, item.id, 'tipo')"  :disabled="!roleEdit">
                <option
                  v-for="tipo of tipos"
                  :value="tipo.value"
                  :key="tipo.id">
                  {{ tipo.label }}
                </option>
              </b-select>
            </div>
          </div>
          <div class="box_right">
            <div class="item_estado">
              <b-select placeholder="Elija el estado" class="input-select-custom select-custom-no" v-model="item.status" @input="putEdificio(item.status,item.id, 'estado')"  :disabled="!roleEdit">
                <option
                  v-for="item of Estados"
                  :value="item.value"
                  :key="item.id">
                  {{ item.label }}
                </option>
              </b-select>
            </div>
            <div class="item_borrar">
              <div>
                  <!-- boton q levanta nel modal -->
                <a @click.prevent.stop @click="preventDialogEventView(item.id)" class="button button-custom-actions ripple wrap-content-btn"  :disabled="!roleEdit"><i class="item_icon item_icon-red material-icons">close</i></a>
                <!-- <a @click.prevent.stop @click="$store.commit('changeModal','delete')" class="button button-custom-actions ripple wrap-content-btn"><i class="item_icon item_icon-red material-icons">close</i></a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edificiosView_body_List-add">
        <div>
          <a @click.prevent.stop @click="$store.commit('changeModal','edificio')" class="button button-custom-actions ripple "><i class="item_icon material-icons">add</i>Agregar edificio</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import { mapGetters, mapMutations } from "vuex";
import { service } from "@/helper/Rest";
export default {
  name: "EdificiosView",
  components: {
    headView
  },
  data() {
    return {
      title: {
        headText: "Configuración",
        subtitle: ""
      },
      subtitleOpt: false,
      Estados: [{label:"Activo", value:"enabled"}, {label:"Inactivo", value:"disabled"}],
      colorBoton: "#1889fa",
      estado: [],
      accses: this.$store.getters.company_id,
      distritos: [],
      tipoSelect: [],
      distritoSelect: [],
      tipos: [{label: "Comercial", value: "commercial"}, {label: "Residencial", value: "residential"}, {label: "Oficina", value: "office"}],
      active: false
    };
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", 'edificios')
  },
  beforeDestroy(){
    this.$store.commit("resetColorChildren", 'edificios')
  },
  created() {
    service.getDistrito().then(response => {
      this.distritos = response.data
      this.$store.dispatch("GETBUILDINGS");
    })
  },
  computed: {
    ...mapGetters(["edificios", "role", "roleEdit"])
  },
  methods: {
    ...mapMutations(["changeBuildingState", "addBuildings"]),
    cambiaEstado: function(index) {
      var obj = {
        estado: this.estado[index],
        i: index
      };
      this.changeBuildingState(obj);
    },
    preventDialogEventView(itemId) {
      this.$dialog.confirm({
        title: "Edificios",
        message:
          "Se eliminará el edificio del sistema.</br> <strong>¿Desea continuar?</strong>",
        confirmText: "Ok",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteEdificio(itemId)
      });
    },
    deleteEdificio: function(id) {
      service.delEdificio(id).then(response => {
        service
          .getEdificios(this.$store.getters.company_id)
          .then(response => {
            this.$store.commit("addBuildings", response.data);
          })
          .catch(err => console.warn(err));
        this.$toast.open({
          message: "Edificio eliminado",
          position: "is-bottom-right",
          type: "ffcolor-is-delete"
        });
      });
    },
    putEdificio: function(item, index, opc){
      var obj = {
        
      }
      switch(opc){
        case 'distrito': obj.district = item; break;
        case 'tipo': obj.type = item; break;
        case 'estado': obj.status = item; break;
      }

      this.$store.dispatch("PUTBUILDING", {id_building: index, obj: obj})
    }
  }
};
</script>

<style lang="scss" >
// @import "../../assets/styles/4.elements/index";
// @import "./../../assets/styles/2.tools/mixins/_navegators.scss";
.wrap_edificiosView {
  // height: 100%;
  position: relative;
}
.edificiosView_body {
  padding-top: 70px;
  padding-left: 30px;
  padding-right: 30px;
  height: 100%;
}
.edificiosView_body__list {
  width: 100%;
}
.edificiosView_body__title {
  width: 100%;
  padding: 15px 0 5px;
}
.edificiosView_body_List-item,
.edificiosView_body_List-add {
  width: 100%;
  // padding-left: 50px;
  max-width: 720px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  margin: 10px 0;
  align-items: flex-start;
}
.edificiosView_body_List-add {
  margin: 25px 0;
}
.item_icon-red {
  color: red;
}

.select-custom-no {
  margin-bottom: 0px;
  border-color: #e6e4e6;
}
.item_borrar {
  margin-left: 20px;

  .wrap-content-btn {
    background-color: white;
    padding: 23px 20px;
    // box-shadow: 0px 0px 0.5px 0px rgba(0, 0, 0, 0.75);
  }
}

.title {
  font-size: 25px;
  font-weight: bold;
  text-align: start;
  // padding-left: 50px;
}
.item_estado {
  .control {
    .select {
      height: 3em;
      select {
        height: 3.2em;
      }
    }
  }
}
.item_select {
  margin-bottom: 1em;
}
.box_left {
  margin-right: 1em;
  width: 350px;
}
.box_right {
  display: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/EdificiosView.vue